import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import AutoBox from './autoBox';
import EntBox from './entBox';

class AENews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { autoData, entData, autoAndEntAd0, autoAndEntAd1, autoAndEntAd2 },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <AutoBox content={autoData} />
                    <EntBox content={entData} />
                </div>
                <div className={styles.ad_box}>
                    <NoSSR>
                        <Ad content={autoAndEntAd0} styleName={styles.fl} />
                    </NoSSR>
                    <NoSSR>
                        <Ad content={autoAndEntAd1} styleName={styles.fr} />
                    </NoSSR>
                </div>
                {autoAndEntAd2 ? <Ad content={autoAndEntAd2} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(AENews);
